module.exports = __webpack_public_path__ + "img/robot.c8a79614.svg";